import React from "react";
import "./hero.css";
import { Link } from "react-router-dom";

const Hero = () => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>
            When <span className="title-word">Creativity</span> Meets Strategy
          </h1>
          <Link to="/services" onClick={handleClick}>
            <button className="btn">Let’s Work Together!</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
